import { MapPin, Phone, Clock, Navigation } from "lucide-react";
import { SITE, waLink, mapsEmbedUrl, mapsDirectionsUrl } from "@/config/site";
import { Reveal, SectionHeading } from "@/components/Reveal";
import { WhatsAppIcon } from "@/components/WhatsAppIcon";

export default function Contacts() {
  return (
    <section id="contatti" className="section-pad scroll-mt-20" data-testid="contacts-section">
      <div className="container-x">
        <SectionHeading number="07" label="Contatti & orari" title="Dove trovarci." />

        <div className="mt-12 grid gap-6 lg:mt-16 lg:grid-cols-5">
          <Reveal className="lg:col-span-2">
            <div className="card flex h-full flex-col gap-7 p-7 sm:p-9">
              <div className="flex items-start gap-4">
                <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl bg-[#edf3ff]">
                  <MapPin className="h-5 w-5 text-[#0050e0]" strokeWidth={1.8} />
                </div>
                <div>
                  <h3 className="font-display text-base font-bold text-[#1c1d1f]">Indirizzo</h3>
                  <p className="mt-1 text-sm leading-relaxed text-[#575a61]">
                    {SITE.name}
                    <br />
                    {SITE.address}
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl bg-[#edf3ff]">
                  <WhatsAppIcon className="h-5 w-5 text-[#0050e0]" />
                </div>
                <div>
                  <h3 className="font-display text-base font-bold text-[#1c1d1f]">WhatsApp</h3>
                  <a
                    href={waLink()}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="contact-whatsapp-button"
                    className="mt-1 inline-block text-sm font-bold text-[#0050e0] underline-offset-4 transition-colors hover:text-[#003fa8] hover:underline"
                  >
                    Scrivici, rispondiamo in negozio
                  </a>
                </div>
              </div>

              {SITE.phone && (
                <div className="flex items-start gap-4">
                  <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl bg-[#edf3ff]">
                    <Phone className="h-5 w-5 text-[#0050e0]" strokeWidth={1.8} />
                  </div>
                  <div>
                    <h3 className="font-display text-base font-bold text-[#1c1d1f]">Telefono</h3>
                    <a href={`tel:${SITE.phone.replace(/\s/g, "")}`} data-testid="contact-phone-link" className="mt-1 inline-block text-sm text-[#575a61] hover:text-[#0050e0]">
                      {SITE.phone}
                    </a>
                  </div>
                </div>
              )}

              <div className="flex items-start gap-4">
                <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl bg-[#edf3ff]">
                  <Clock className="h-5 w-5 text-[#0050e0]" strokeWidth={1.8} />
                </div>
                <div>
                  <h3 className="font-display text-base font-bold text-[#1c1d1f]">Orari di apertura</h3>
                  {SITE.openingHours ? (
                    <ul className="mt-1 space-y-1 text-sm text-[#575a61]">
                      {SITE.openingHours.map((o) => (
                        <li key={o.days}>
                          <span className="font-medium text-[#1c1d1f]">{o.days}:</span> {o.hours}
                        </li>
                      ))}
                    </ul>
                  ) : (
                    <p className="mt-1 text-sm leading-relaxed text-[#575a61]">
                      Scrivici su WhatsApp per confermare gli orari del giorno.
                    </p>
                  )}
                </div>
              </div>

              <a
                href={mapsDirectionsUrl}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="contacts-directions-button"
                className="btn-primary mt-auto w-full"
              >
                <Navigation className="h-4 w-4" />
                Indicazioni stradali
              </a>
            </div>
          </Reveal>

          <Reveal delay={0.12} className="lg:col-span-3">
            <div className="h-full min-h-[320px] overflow-hidden rounded-[2rem] border border-black/[0.06] bg-white">
              <iframe
                title="Mappa — Farma Store, Via Casilina 193, Castrocielo (FR)"
                data-testid="map-iframe"
                src={mapsEmbedUrl}
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                allowFullScreen
                className="h-full min-h-[320px] w-full border-0"
              />
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
